
export const SEARCH_QUERY_TOOL_ROUTE = "/search-query-tool" ;
export const SEARCH_QUERY_TOOL_RESULT_ROUTE = "/search-query-tool-results" ;
export const SEARCH_QUERY_TOOL_DETAILS_ROUTE = "/search-query-tool-details"
export const MEMBERS_ROUTE = "/members" ;
export const ADD_MEMBERS_ROUTE = "/add-members" ;
export const MEMBER_OVERVIEW_ROUTE = "/member-overview" ;
export const EDIT_MEMBERS_ROUTE = "/edit-member" ;
export const MEMBER_PROFILE_ROUTE = "/member-profile" ;
export const TASKS_ROUTE = "/tasks" ;
export const FORMS_LIST_ROUTE = "/forms-list" ;
export const FORMS_ROUTE = "/forms" ;
export const SUBMITTED_FORMS_ROUTE = "/submitted-forms" ;
export const FRONT_DESK_FORM = "/front-desk-form" ;
export const FRONT_DESK_FORM_LIST_ROUTE = "/front-desk-form-list" ;
export const DOWNLOADABLE_FORMS_ROUTE = "/downloadable-forms" ;
export const FRONT_DESK_SUBMITTED_FORMS_ROUTE = "/front-desk-submitted-forms" ;
export const ACTIVITY_LOGS_ROUTE = "/activity-logs" ;
export const SUBSCRIBER_LIST_ROUTE = "/subscribers" ;
export const FREE_ALERT_SUBSCRIBER_LIST_ROUTE = "/free-alert-subscribers" ;